import { createFileRoute } from '@tanstack/react-router';
import { GroupServicesPage } from '@/features/settings/group-services-page.js';

export const Route = createFileRoute('/_app/settings/groups/$id/services')({
  component: GroupServicesPage,
});
